import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 90vw;
  max-width: 1000px;
  height: 80vh;
  max-height: 700px;
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  border-radius: 8px;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  min-height: 0;
`;

export const Sidebar = styled.div<{ $showOnMobile?: boolean }>`
  width: 350px;
  border-right: 1px solid ${({ theme }) => theme.colors?.gray02};
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media screen and (max-width: 768px) {
    width: 100%;
    border-right: none;
    display: ${({ $showOnMobile }) => ($showOnMobile ? 'flex' : 'none')};
    transition: transform 0.3s ease-in-out;
  }
`;

export const MainContent = styled.div<{ $showOnMobile?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;

  @media screen and (max-width: 768px) {
    display: ${({ $showOnMobile }) => ($showOnMobile ? 'flex' : 'none')};
    width: 100%;
    transition: transform 0.3s ease-in-out;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  min-height: 400px;
`;

